import { createContext } from "react";
const ProductsStockContext = createContext({});

export default ProductsStockContext;
